import { type CareWords, careWords } from "@healthos/shared";
import { useCoachSettings } from "../../coaching/coaching-queries";

/** The words a professional's workspace speaks: a coach's coachees, or a clinician's patients. */
export function useProfessionalWords(enabled = true): CareWords {
  return careWords(useCoachSettings(enabled).data?.practice ?? "coaching");
}
